import { isMobile, isIPad13 } from 'react-device-detect'

export const detectMobile = () => isMobile || isIPad13
export const detectIpad = () => isIPad13

export const byPlatform = (mobileCase, desktopCase) =>
    detectMobile() && !detectIpad() ? mobileCase : desktopCase
